export default "__VITE_ASSET__CmqQjZb9__"